// Frecency-style recent app tracker. Stored in localStorage; survives reloads
// but not cross-device. Cap at 8 entries; bump score on each launch.
const STORAGE_KEY = "g1_universal_launcher_recent_v1";
const MAX_ENTRIES = 8;
function read() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw)
            return [];
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed))
            return [];
        return parsed.filter((e) => typeof e === "object" &&
            e !== null &&
            typeof e.appId === "string" &&
            typeof e.score === "number" &&
            typeof e.lastUsed === "number");
    }
    catch {
        return [];
    }
}
function write(entries) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
    }
    catch {
        // Storage may be disabled in private mode; silently degrade to no-op.
    }
}
export function recordRecent(appId) {
    const now = Date.now();
    const entries = read();
    const idx = entries.findIndex((e) => e.appId === appId);
    if (idx >= 0) {
        const e = entries[idx];
        if (e)
            entries[idx] = { ...e, score: e.score + 1, lastUsed: now };
    }
    else {
        entries.push({ appId, score: 1, lastUsed: now });
    }
    entries.sort((a, b) => {
        if (b.score !== a.score)
            return b.score - a.score;
        return b.lastUsed - a.lastUsed;
    });
    write(entries.slice(0, MAX_ENTRIES));
}
export function getRecent() {
    return read().map((e) => e.appId);
}
export function clearRecent() {
    try {
        localStorage.removeItem(STORAGE_KEY);
    }
    catch {
        // ignore
    }
}
//# sourceMappingURL=recent.js.map